/**
 * Une clases condicionalmente. Minimal, sin dependencias.
 * (No hace merge de conflictos de Tailwind como tailwind-merge; para el UI kit
 * basta con esto — evitá pasar utilidades contradictorias.)
 */
export type ClassValue =
  | string
  | number
  | null
  | false
  | undefined
  | ClassValue[];

export function cn(...inputs: ClassValue[]): string {
  const out: string[] = [];
  const walk = (v: ClassValue) => {
    if (!v && v !== 0) return;
    if (Array.isArray(v)) v.forEach(walk);
    else out.push(String(v));
  };
  inputs.forEach(walk);
  return out.join(" ");
}
